import { Layout } from "antd";
import styled from "styled-components";

export const MainHeader = styled.div`
  background-color: #f4f4f4;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  
  h1 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  background-color: white;
  height: 100%;
  overflow: auto;
`;

export const ProfileContainer = styled.div`
  padding: 24px;
  max-width: 1500px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const Section = styled.div`
  margin-bottom: 40px;

  @media (max-width: 768px) {
    margin-bottom: 32px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const SectionDescription = styled.p`
  color: #9B9B9B;
  font-size: 14px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 20px;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const InputGroup = styled.div`
  flex: 1;
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;

  &:disabled {
    background-color: #f5f5f5;
    color: #666;
  }
`;

export const SaveButton = styled.button`
  background-color: #1a4b8c;
  color: white;
  padding: 12px 24px;
  border-radius: 25px;
  border: none;
  font-size: 16px;
  cursor: pointer;
  float: right;
  min-width: 200px;

  &:hover {
    background-color: #153d73;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #d9d9d9;
  margin: 40px 0;
  width: 100%;

  @media (max-width: 768px) {
    margin: 32px 0;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    .ant-btn {
      width: 100%;
    }
  }
`;

export const AlertWrapper = styled.div`
  margin-bottom: 24px;
`;  